export const WHATSAPP_APPOINTMENT_CREATION = `[patient_name],
Agendamento realizado para *[date_hour]* com o(a) profissional *[professional_name]*!

[facility_name]
[facility_address]`;

export const WHATSAPP_APPOINTMENT_CONFIRMATION = `[patient_name],
Você tem atendimento *[date_hour]* com o(a) profissional *[professional_name]*.

Clique no link a seguir para confirmar sua presença:
[appointment_link]

[facility_name]
[facility_address]`;

export const WHATSAPP_WEB_APPOINTMENT_CONFIRMATION = `[patient_name],
Você tem atendimento *[date_hour]* com o(a) profissional *[professional_name]*.
Podemos confirmar sua presença?

[facility_name]
[facility_address]`;

export const WHATSAPP_APPOINTMENT_REMINDER = `[patient_name],
Apenas para lembrá-lo de seu atendimento *[date_hour]* com o(a) profissional *[professional_name]*.
Recomendamos que chegue com 10 minutos de antecedência.

[facility_name]
[facility_address]`;

export const WHATSAPP_TELEMEDICINE_LINK = `[patient_name],
Seu atendimento por telemedicina com o(a) profissional *[professional_name]* está agendado para *[date_hour]*.

Acesse a sala pelo link abaixo, alguns minutos antes do horário:
[telemedicine_link]

[facility_name]`;

export const WHATSAPP_DIGITAL_PRESCRIPTION = `[patient_name],
Sua receita emitida pelo(a) profissional *[professional_name]* está disponível no link abaixo:
[document_link]

O link é válido por 30 dias. Apresente a receita na farmácia pelo celular ou, se preferir, imprima.

[facility_name]`;
